module.exports = __webpack_public_path__ + "static/media/1.42147c44.svg";